import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BloqMark } from "@/components/brand/BloqLogo";
import { WaitlistForm } from "@/components/lander/WaitlistForm";

const LINES = [
  { t: "$ bloqtalk --connect", c: "text-white" },
  { t: "> initializing secure channel…", c: "text-bloq-muted" },
  { t: "> BLOQ Shield ....... ONLINE", c: "text-bloq-mint" },
  { t: "> Trust Gates ....... ARMED", c: "text-bloq-mint" },
  { t: "> status: PRIVATE_BETA", c: "text-bloq-blue" },
  { t: "> public_access(): DENIED", c: "text-destructive" },
  { t: "> request_early_access() ↓", c: "text-white" },
];

// Variant 2 — "Command Console": terminal / crypto-native.
export default function Console() {
  const [shown, setShown] = useState(0);
  useEffect(() => {
    if (shown >= LINES.length) return undefined;
    const id = setTimeout(() => setShown((s) => s + 1), 420);
    return () => clearTimeout(id);
  }, [shown]);

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-bloq-bg px-5 py-10 text-white">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(1,250,189,0.35) 1px, transparent 1px), linear-gradient(90deg, rgba(1,250,189,0.35) 1px, transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      />
      <div className="pointer-events-none absolute -bottom-20 left-1/2 h-[420px] w-[620px] -translate-x-1/2 rounded-full bg-bloq-mint/10 blur-[130px]" />

      <div className="relative z-10 w-full max-w-2xl">
        <div className="mb-5 flex items-center justify-center gap-3">
          <BloqMark size={30} />
          <span className="font-heading text-sm font-bold uppercase tracking-[0.3em] text-bloq-muted">bloqtalk // secure shell</span>
        </div>

        <div className="overflow-hidden rounded-2xl border border-white/12 bg-black/60 shadow-glow backdrop-blur-xl">
          <div className="flex items-center gap-2 border-b border-white/8 bg-white/5 px-4 py-3">
            <span className="h-3 w-3 rounded-full bg-destructive/70" />
            <span className="h-3 w-3 rounded-full bg-amber-400/70" />
            <span className="h-3 w-3 rounded-full bg-bloq-mint/70" />
            <span className="ml-3 font-mono text-xs text-bloq-muted">~/bloqtalk/access</span>
          </div>
          <div className="min-h-[240px] space-y-1.5 p-5 font-mono text-sm sm:text-[15px]">
            {LINES.slice(0, shown).map((l, i) => (
              <div key={i} className={l.c}>{l.t}</div>
            ))}
            {shown < LINES.length && <span className="inline-block h-4 w-2 animate-pulse bg-bloq-mint align-middle" />}
            {shown >= LINES.length && (
              <div className="pt-4">
                <WaitlistForm
                  compact
                  placeholder="enter email to join the queue…"
                  buttonLabel="run"
                  inputClassName="font-mono rounded-lg bg-black/50"
                  buttonClassName="rounded-lg"
                />
              </div>
            )}
          </div>
        </div>

        <div className="mt-6 flex items-center justify-center gap-5 font-mono text-xs text-bloq-muted">
          <Link to="/privacy" className="hover:text-white" data-testid="lander-privacy-link">/privacy</Link>
          <Link to="/terms" className="hover:text-white" data-testid="lander-terms-link">/terms</Link>
          <Link to="/data-security" className="hover:text-white" data-testid="lander-security-link">/data-security</Link>
          <Link to="/delete-account" className="hover:text-white" data-testid="lander-delete-link">/delete-account</Link>
          <span>© {new Date().getFullYear()} bloqtalk</span>
        </div>
      </div>
    </div>
  );
}
